import React from 'react';
import FlatButton from 'material-ui/FlatButton';

const BTN_STYLE = { minWidth: 36, height: 30, lineHeight: '30px' };
const LABEL_STYLE = { padding: '0 6px', fontSize: 12, color: '#333' };

const safeCan = (editor, name) => {
  try {
    const fn = editor.can()[name];
    return typeof fn === 'function' ? fn() : false;
  } catch (_e) {
    return false;
  }
};

const TableToolbar = ({ editor }) => {
  if (!editor) return null;
  const cmd = (fn) => (e) => {
    e.preventDefault();
    fn(editor.chain().focus()).run();
  };

  const btn = (label, tooltip, handler, disabled = false) => (
    <FlatButton
      label={label}
      title={tooltip}
      onMouseDown={handler}
      disabled={disabled}
      style={BTN_STYLE}
      labelStyle={LABEL_STYLE}
    />
  );

  return (
    <div className="cro-table-toolbar" onMouseDown={(e) => e.preventDefault()}>
      {btn('+R↑', 'Vložit řádek nad', cmd((c) => c.addRowBefore()))}
      {btn('+R↓', 'Vložit řádek pod', cmd((c) => c.addRowAfter()))}
      {btn('−R', 'Smazat řádek', cmd((c) => c.deleteRow()))}
      {btn('+C←', 'Vložit sloupec vlevo', cmd((c) => c.addColumnBefore()))}
      {btn('+C→', 'Vložit sloupec vpravo', cmd((c) => c.addColumnAfter()))}
      {btn('−C', 'Smazat sloupec', cmd((c) => c.deleteColumn()))}
      {btn('HR', 'Záhlaví řádek', cmd((c) => c.toggleHeaderRow()))}
      {btn(
        'Sloučit',
        'Sloučit buňky — nejprve označte 2+ buněk tažením myši',
        cmd((c) => c.mergeCells()),
        !safeCan(editor, 'mergeCells'),
      )}
      {btn(
        'Rozdělit',
        'Rozdělit buňku — kurzor musí být uvnitř dříve sloučené buňky',
        cmd((c) => c.splitCell()),
        !safeCan(editor, 'splitCell'),
      )}
      {btn('✕T', 'Smazat tabulku', cmd((c) => c.deleteTable()))}
    </div>
  );
};

export default TableToolbar;
